import React from "react";
import Confetti from "react-confetti";
import { motion } from "framer-motion";

const PaginaSucesso = () => {
  return (
    <>
      {/* Camada de gradiente fixa cobrindo tudo */}
      <div className="fixed inset-0 -z-10 animated-bg pointer-events-none" />

      {/* Conteúdo */}
      <div className="relative z-10 flex flex-col min-h-screen overflow-x-hidden">
        <div className="flex flex-1 flex-col items-center justify-center text-center text-white overflow-hidden">
          <Confetti recycle={false} numberOfPieces={400} />

          {/* Ícone */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 200, damping: 15 }}
            className="bg-white rounded-full p-6 shadow-xl mb-6"
          >
            <motion.svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-24 h-24 text-green-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 1.2, ease: "easeInOut" }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </motion.svg>
          </motion.div>

          {/* Texto */}
          <motion.h1
            className="text-5xl font-extrabold mb-3 drop-shadow-lg"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Obrigado!
          </motion.h1>

          <motion.p
            className="text-lg mb-2"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 1 }}
          >
            Seus dados foram enviados com sucesso.
          </motion.p>

          <motion.p
            className="text-md opacity-80"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 1 }}
          >
            Você já pode fechar esta aba.
          </motion.p>
        </div>
      </div>
    </>
  );
};

export default PaginaSucesso;
